module.exports = __webpack_public_path__ + "img/AKA 2001.8b20d940.jpg";